<template>
  <v-card outlined class="pa-3 h-100">
    <div class="d-flex align-center">
      <v-avatar :color="`${cor} lighten-4`" size="40" class="mr-3">
        <v-icon :color="cor" small>{{ icone }}</v-icon>
      </v-avatar>
      <div class="flex-grow-1">
        <div class="text-caption grey--text text--darken-1">
          {{ titulo }}
          <span v-if="subtitulo" class="grey--text">{{ subtitulo }}</span>
        </div>
        <v-skeleton-loader v-if="carregando" type="heading" width="60" />
        <div v-else class="text-h5 font-weight-bold">{{ valor }}</div>
      </div>
    </div>
  </v-card>
</template>

<script>
export default {
  name: "ECardIndicador",
  props: {
    titulo: { type: String, required: true },
    subtitulo: { type: String, default: null },
    valor: { type: [Number, String], default: 0 },
    icone: { type: String, default: "mdi-account-group" },
    cor: { type: String, default: "primary" },
    carregando: { type: Boolean, default: false },
  },
};
</script>

<style scoped>
.h-100 {
  height: 100%;
}
</style>
